<template>
  <fieldset class="table-scale">
    <legend>Плотность строк</legend>
    <label v-for="option in options" :key="option.value" :class="{ active: modelValue === option.value }">
      <input type="radio" :name="controlName" :value="option.value" :checked="modelValue === option.value" @change="$emit('update:modelValue', option.value)">
      <span>{{ option.label }}</span>
    </label>
  </fieldset>
</template>

<script>
let nextId = 0;

export default {
  name: 'TableScaleControl',
  props: { modelValue: { type: String, default: 'normal' } },
  emits: ['update:modelValue'],
  setup() {
    return {
      controlName: `table-scale-${++nextId}`,
      options: [
        { value: 'compact', label: 'Компактно' },
        { value: 'normal', label: 'Обычно' },
        { value: 'comfortable', label: 'Свободно' },
        { value: 'large', label: 'Крупно' },
      ],
    };
  },
};
</script>

<style scoped>
.table-scale { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; margin: 0 0 10px; padding: 0; border: 0; color: #344054; }
.table-scale legend { float: left; margin-right: 8px; font-size: 13px; font-weight: 700; }
.table-scale label { display: inline-flex; align-items: center; min-height: 28px; padding: 0 9px; border: 1px solid #d0d5dd; background: #fff; color: #475467; font-size: 12px; cursor: pointer; user-select: none; }
.table-scale label:first-of-type { border-radius: 4px 0 0 4px; }
.table-scale label:last-of-type { border-radius: 0 4px 4px 0; }
.table-scale label + label { margin-left: -5px; }
.table-scale label.active { z-index: 1; border-color: #007bff; background: #eef6ff; color: #007bff; }
.table-scale input { position: absolute; width: 1px; height: 1px; opacity: 0; }
.table-scale label:focus-within { outline: 2px solid #80bdff; outline-offset: 1px; }
</style>
